import React, {
    useCallback,
    useEffect,
    useState
} from "react";
import { Alert, Container } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { getUserCompany } from "../services/UserService";
import { getCompanyServices } from "../services/companyservice";
import LoadingLoginScreen from "./LoadingLoginScreen";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

export const CompanyDetails = ({ match }) => {
    const [company, setCompany] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState("");

    const [companyServices, setCompanyServices] = useState([]);

    const { SearchBar } = Search;

    const { currentUser } = useAuth();


    const fetchCompanyDetails = useCallback(async () => {

        try {
            setLoading(true);
            const userCompany = await getUserCompany(currentUser.uid);
            const companyServices = await getCompanyServices(userCompany);

            setCompany(userCompany);
            setCompanyServices(companyServices);
            setLoading(false);

        } catch (e) {

        }
    }, [])


    const columns = [

        {

            dataField: 'QR',
            text: 'QR',
            sort: true,
        }, {
            dataField: 'company',
            text: 'Företag',
            sort: true,
        }, {
            dataField: 'service',
            text: 'Tjänst',
            sort: true,
        },

    ];

    useEffect(() => {


        fetchCompanyDetails()
    }, [fetchCompanyDetails]);

    return (
        <React.Fragment>
            {loading ? <LoadingLoginScreen /> :
                <Container fluid className={"leadsGrid"}>

                    <Container>
                        Tjänster som ni erbjuder.
                        <hr />
                    </Container>
                    <ToolkitProvider
                        keyField="id"
                        data={companyServices}
                        columns={columns}
                        search
                    >
                        {props => (
                            <div>
                                <SearchBar placeholder="Sök" srText={null}
                                    className="SearchBar" {...props.searchProps} />
                                <BootstrapTable wrapperClasses="table-responsive" {...props.baseProps} />
                            </div>
                        )}
                    </ToolkitProvider>

                </Container>
            }
        </React.Fragment>

    )
}
